<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">FIGHTING NAPOLEON AT HOME</h1>
<h1 class="titlea">THE REAL STORY OF A NATION AT WAR WITH ITSELF</h1>
<p class="author">PAUL L. DAWSON</p>
<div class="image_containerf">
<img alt="images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?c0b3b16e